var map = {
	"./instrument-acoustic-guitar.svg": [
		430,
		19
	],
	"./instrument-bass-guitar.svg": [
		431,
		20
	],
	"./instrument-cello.svg": [
		432,
		21
	],
	"./instrument-dj.svg": [
		433,
		22
	],
	"./instrument-double-bass.svg": [
		434,
		23
	],
	"./instrument-drums.svg": [
		435,
		24
	],
	"./instrument-electric-guitar.svg": [
		436,
		25
	],
	"./instrument-harp.svg": [
		437,
		26
	],
	"./instrument-keyboard.svg": [
		438,
		27
	],
	"./instrument-piano.svg": [
		439,
		28
	],
	"./instrument-saxophone.svg": [
		440,
		29
	],
	"./instrument-sing.svg": [
		441,
		30
	],
	"./instrument-trumpet.svg": [
		442,
		31
	],
	"./instrument-violin.svg": [
		443,
		32
	],
	"./instrument-xylophone.svg": [
		444,
		33
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 376;
module.exports = webpackAsyncContext;